<template>
  <div class="item-component s-item-liquidfill">
    <div class="s-item-title">
      <h4 class="chart-title">
        <i class="el-icon-s-grid"></i>
        预报到事项完成人数
      </h4>
    </div>

    <chart-six style="height: 90%" :value="chartData"></chart-six>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ChartSix from "../charts/chart06";
// import { chartData06 } from "@/assets/json/chartData";
export default {
  components: {
    ChartSix,
  },
  data() {
    return {
      // chartData: 10,
      chartData: [],
      enrollmentYear: "",
    };
  },
  computed: {
    ...mapState("dic", ["SUCCESS_CODE", "_CURRENTYEAR","_CURRENT_ACADEMIC"]),
  },
  created() {
    this.enrollmentYear = this._CURRENTYEAR[0].value;
    this.getLinkDoneNum();
  },
  mounted() {},
  methods: {
    // 迎新事项统计
    getLinkDoneNum() {
      let params = { enrollmentYear: this.enrollmentYear, academicDegree: this._CURRENT_ACADEMIC };
      this.$http
        .get("/welcome-forecast/statistics/getForecastLinkDoneNum",{params})
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            console.log(res);
            if (res.data) {
              let data = res.data;
              this.chartData = data.map((item) => {
                return {
                  name: item.name,
                  value: item.doneNum,
                };
              });
            }
          } else {
            this.$message.error(`${res.msg}`);
          }
        })
        .catch((err) => {
          this.$message.error(`${err}`);
        });
    },
  },
};
</script>

<style>
</style>